"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RedBlackWarning = function RedBlackWarning() {
	return _react2.default.createElement(
		"g",
		{
			id: "RedBlackWarning",
			stroke: "none",
			strokeWidth: "1",
			fill: "none",
			fillRule: "evenodd"
		},
		_react2.default.createElement("image", {
			id: "key_over",
			x: "0",
			y: "0",
			width: "500",
			height: "500",
			xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAaCAYAAACgoey0AAAABGdBTUEAALGPC/xhBQAABE5JREFUSA21Vm1MU2cUPrf39ptSRumHJWwTN4OZ/DBEZxaWODM1Ov2D4LRo/AqmIsn8SZYt2RJ/LGZZiUxN07RlupGFbanOf8Zk8xdFFHUCrRaWIP0EVmtbLIVLu/e92729tJdCTXiTm/fcc55znntOz3nfArzG8nd1fedpbqY9JtN86PLljtcIAUSpTlM224dTLtfdzMIC40upVBnN/v3v6k+d+ruUWKJSwBib9Hh+xqSVe/eCYuNGoBMJUWp8/GapcUoiDnZ3dyafPDGSZWVgOH0ajB0dQBAEJO7ffy9ktbaUQr5q4mxfnxwRfIWD60+cALK8HOR1dfDGnj2QzWSI5KNHtjUh9o+P96WDQals/XpAvynHgTPHFUiNjakDFsv3nGEFYVUZh53O+nh//yc4Fi4viHJupFoN+uPHGZq4222O9PbqV+BkzLkIRdApr9e1mEoRFTt2gLK+vgCpOXAA5LW1sBCNkqlnz24UAAQUKxIHr15tSw4N1YpkMlh35oxACKRCFTCeO8fYkgMD70ccjo+FgTltUWLUUGTiwQNLFoDQmUxAVVUxnj7fGPQ4fmCeQCDI6BSoEhU7d0KGponk48c/5SiEpaLEgYkJR3piQik1GqHq4EEuwuTzSXAiYvzMTM9welwRUi6H2dFRXeDSpa85g4CwLHHI6XwbNctR7LPObAZCLObcFQpFTlbmZKqyEnRHGRdI3LvXOW23qzhgnrAscRqdRnQ8LlJt2waq7duXuCl4ZPyPwKCqpiaQ1tTAfCQiSYXDvyxx5L0IEkdstqbE4GC9CGVpPHuWB/9P5JMpeR/BWEkSjO3tjIgqtnu6p6ehIABSCBInHj6049NIg75eUl1d4Kfkl5ons8CyhgZQNzZCZm6OSIyM/Mbq+XsBsd9i6Xrl81WINRrQtbbysZzMZkxRJEgkEk7PF3BfiKRSQEfpW0JX5xLihMOhReVhBtLQ1gZ4doWW/P8s2V0II9bpQHv4MGNCZ/zFrNWa606kpfhO0clJFx2NUsrNm5mZ5Nv4skQiBtfNX4EQFb/OtYcOwYvbt2HO75cHYrEfUYxP2ThcxiG7/aPEwMAHBO8UYkH5eyaTgf5+N4yOePJNS97xCLLN+dLtbp66fv0dFsARvxoe7mUu+H37QLZhA2sX3P/84y5c/OZb+LzzCwgFQ4IYVolHEY/kYjIpmvV6f2f1DHGou/vL2eFhA4XuWP3Jk6xt2b3mzRqQod9fq9VCubp8WRxrwOOFRzM5OFgXtlpNjD587ZrSe+xY+q9du7L/3LqVXe1Kp+ezNL24Wng27HBkMYfPbH6JnAjys61bb6Bs6+SovNXnz6ProHjDsFmQ6KAQrdBcLBbvyk2b4MWdO5D2+6X0zIyeQv+hdmOD9sgRoGMxLK7Z0ra0QPDKFUg9fdpKESSZwUzPL1xYM8L8wIRUOk9VNDa2x4eGuhZjMXk+YC3exQZDVLVlS+u//kTOUVHxjwkAAAAASUVORK5CYII="
		})
	);
};

exports.default = RedBlackWarning;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/RedBlackWarning.js
// module id = 2980
// module chunks = 4